import { format } from 'date-fns';
import { ArticleType } from '../../../domain/articleType';
import { Article } from '../../../domain/graphcms';
import { ArticleNextPrevFooterProps } from '../../components/article-next-prev-footer/ArticleNextPrevFooter';
import { ArticleListProps } from '../../components/articles-list/ArticlesList';
import { RelatedArticleItem } from '../../components/related-articles/RelatedArticles';
import { buildArticleURLObject, goToPage, slugIt } from '../../utils/links';

export type NextPrevResult = Pick<ArticleNextPrevFooterProps, 'prev' | 'next'>;

export function mapArticlesNodes(articles: Article[], type: ArticleType): Omit<RelatedArticleItem, 'onClick'>[] {
  return articles.map((article) => {
    const urlObject = buildArticleURLObject({
      id: article.id,
      slug: slugIt(article.alternateTitle || article.title),
    }, type);

    return {
      id: article.id,
      title: article.title,
      urlObject,
      thumbnail: {
        url: article?.imageBlock?.image?.url,
        alt: article?.imageBlock?.imageAlt,
      },
    };
  });
}

export function getNextPrev(older: Article[], newer: Article[], type: ArticleType): NextPrevResult {
  const nextPrev: NextPrevResult = {};
  const prev = mapArticlesNodes(older, type)[0];
  const next = mapArticlesNodes(newer, type)[0];
  if (prev) {
    nextPrev.prev = {
      ...prev,
    };
  }
  if (next) {
    nextPrev.next = {
      ...next,
    };
  }
  return nextPrev;
}

export function formatPublishDate(publishDate: string, dateFormat: string = 'dd/MM/yyyy'): string {
  return format(new Date(publishDate), dateFormat);
}

export function mapArticles(articles: Article[], type: ArticleType): ArticleListProps['articles'] {
  return articles.map((article) => {
    const urlObject = buildArticleURLObject({
      id: article.id,
      slug: slugIt(article.alternateTitle || article.title),
    }, type);

    const date = formatPublishDate(article.published);

    const dateLabel = type === ArticleType.NEWS
      ? 'Pubblicata il'
      : 'Aggiornata il';

    return {
      id: article.id,
      title: article.title,
      date,
      dateLabel,
      urlObject,
      onClick: () => goToPage(urlObject),
      abstract: article.abstract,
      imageAlt: article.imageBlock && article.imageBlock.imageAlt,
      imageURL: article.imageBlock && article.imageBlock.image.url,
    };
  });
}
